<template>
  <div class="screen screen__search">
    <el-container direction="vertical">
      <section class="search__form">
        <div class="page--container">
          <div class="page--section">
            <el-row :gutter="40">
              <el-col>
                <search-input :initialQuery="$route.params.searchQuery" />
              </el-col>
            </el-row>
          </div>
        </div>
      </section>
      <section class="search__results">
        <div class="page--container">
          <div class="page--section">
            <el-row :gutter="40">
              <el-col :xs="24" :md="{ span: 12, offset: 6 }">
                <search-results />
              </el-col>
            </el-row>
          </div>
        </div>
      </section>
    </el-container>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Input from '@/components/search/Input.vue';
import Results from '@/components/search/Results.vue';

export default {
  name: 'Search',
  components: {
    'search-results': Results,
    'search-input': Input,
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';

.search__form {
  background-color: $--color-black;
}
</style>
